import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroReport'), ...new Mutations('xeroReports') };
